<script setup lang="ts">

import { computed } from "vue";
import type { IActivateVehicleModel } from '../IActivateVehicleModel';

type Props = { model: IActivateVehicleModel }
const { model } = defineProps<Props>();

const isValid = computed( () => ( model.query ?? '' ).length >= 3 );

</script>

<template>

    <div class="flex flex-col gap-6 justify-start px-4 3xl:px-6">

        <!-- REGO / QUERY -->
        <div class="py-1 3xl:py-2 px-2 3xl:px-4 bg-white/[7%] rounded">
            <TextField label="Enter the vehicle's rego"
                       v-model="model.query"
                       hide-details="auto"
                       bg-color="transparent"
                       variant="solo"
                       autofocus
                       required
                       minlength="3"
                       maxlength="30"
                       flat
                       @keypress.enter="model.tryToFindVehicle()"
                       @input="() => { model.query = ( model.query ?? '' ).toUpperCase() }">
            </TextField>
        </div>

        <p class="text-sm lg:text-base 3xl:text-lg text-center tracking-wider">
            We'll check to see if we already<br/>
            have this vehicle in the Carparc
        </p>

        <Button :disabled="isValid == false"
                :variant="isValid ? 'flat' : 'flat'"
                :color="isValid ? 'secondary' : 'white'"
                size="large"
                type="submit"
                class="mx-auto w-full 3xl:max-w-[300px] !h-12 lg:!h-14 rounded-[5px]"
                :style="{ 'background-color': isValid == false ? 'rgba( 255, 255, 255, 0.05 ) !important' : 'white'  }"
                @click="() => model.tryToFindVehicle()">
            Find Vehicle
        </Button>

    </div>

</template>
